import * as yup from "yup";

import { WorkflowRequestModalForm } from "../models";
import { MAX_COMMENT_LENGTH } from "./Workflow";

export const WORKFLOW_REQUEST_MODAL_DEFAULT_VALUES: WorkflowRequestModalForm = {
  comment: null,
  scheduledAt: null,
};

export const WORKFLOW_REQUEST_MODAL_VALIDATION = yup.object().shape({
  comment: yup.string().trim().max(MAX_COMMENT_LENGTH).nullable(),
  scheduledAt: yup.string().trim().nullable(),
});
